import React, {ReactElement} from 'react';
import Props from './typings';
import {StyledColourSelector, StyledColourContainer} from './styles';

const ColourSelector = ({colorArray, selected, callback}: Props): ReactElement => {
  return (
    <StyledColourContainer>
      {colorArray.map((color) => (
        <StyledColourSelector
          key={color}
          $color={color}
          className={`colorItem ${selected.includes(color) ? 'selected' : ''}`}
          onClick={() => callback(color)}
        >
          <span></span>
        </StyledColourSelector>
      ))}
    </StyledColourContainer>
  );
};

export default ColourSelector;
